<template>
  <div class="auth-guard-container">
    <!-- Pantalla de carga durante la autenticación -->
    <div v-if="isAuthenticating" class="auth-loading">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <h3>Verificando autenticación...</h3>
      <p>Por favor, espere mientras verificamos sus credenciales.</p>
    </div>

    <!-- Contenido protegido (solo se muestra si está autenticado) -->
    <div v-else-if="isAuthenticated" class="authenticated-content">
      <slot></slot>
    </div>

    <!-- Pantalla de error de autenticación -->
    <div v-else class="auth-error">
      <div class="error-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <h3>Error de Autenticación</h3>
      <p>No se pudo verificar su autenticación. Será redirigido al login.</p>
      <button @click="redirectToLogin" class="btn btn-primary">
        Ir al Login
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject } from 'vue'

export default {
  name: 'AuthGuard',
  setup() {
    const isAuthenticating = ref(true)
    const isAuthenticated = ref(false)
    const widgetAuth = inject('widgetAuth')

    const redirectToLogin = () => {
      widgetAuth.redirectToLogin()
    }

    onMounted(async () => {
      try {
        // Intentar inicializar la autenticación
        const authResult = await widgetAuth.init()
        
        if (authResult) {
          isAuthenticated.value = true
          console.log('Usuario autenticado:', widgetAuth.getUserInfo())
        } else {
          isAuthenticated.value = false
          console.error('Fallo en la autenticación')
        }
      } catch (error) {
        console.error('Error en AuthGuard:', error)
        isAuthenticated.value = false
      } finally {
        isAuthenticating.value = false
      }
    })

    return {
      isAuthenticating,
      isAuthenticated,
      redirectToLogin
    }
  }
}
</script>

<style scoped>
.auth-loading,
.auth-error {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  z-index: 9999;
  text-align: center;
  padding: 2rem;
}

.loading-spinner {
  margin-bottom: 1.5rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-icon {
  font-size: 2.5rem;
  color: #dc3545;
  margin-bottom: 1rem;
}

.auth-loading h3,
.auth-error h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 500;
}

.auth-loading p,
.auth-error p {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.4;
  font-size: 0.9rem;
}

.btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-block;
}

.btn:hover {
  background: #0056b3;
}
</style>
